import React, { useEffect, useState } from 'react';

import { Modal, Button, Typography, Space } from 'antd';
import QRCode from 'qrcode';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const { Text } = Typography;

const QrWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;

  img {
    width: 220px;
    height: 220px;
  }
`;

const Hint = styled(Text)`
  display: block;
  text-align: center;
  color: rgba(0, 0, 0, 0.55);
  margin-bottom: 8px;
`;

const buildDeeplink = (host, organizationName, workspace) => {
  const params = new URLSearchParams({
    host,
    organization_name: organizationName,
  });
  if (workspace) {
    params.set('workspace', workspace);
  }
  return `vanta-app://config?${params.toString()}`;
};

const AppSetupModal = ({ open, onClose, host, organizationName, workspace }) => {
  const { t } = useTranslation();
  const [qrDataUrl, setQrDataUrl] = useState(null);

  const url = buildDeeplink(host, organizationName, workspace);

  useEffect(() => {
    if (!open) return;
    QRCode.toDataURL(url, { width: 440, margin: 1 })
      .then(setQrDataUrl)
      .catch((err) => {
        console.error('QR generation failed:', err);
        setQrDataUrl(null);
      });
  }, [open, url]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={t('operator.login.app_setup.modal_title', { organizationName })}
      footer={null}
      width={400}
      destroyOnClose
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Hint>{t('operator.login.app_setup.scan_hint')}</Hint>

        <QrWrapper>
          {qrDataUrl && <img src={qrDataUrl} alt="Vanta App config QR" />}
        </QrWrapper>

        <Button type="primary" href={url} block>
          {t('operator.login.app_setup.open_in_app')}
        </Button>
      </Space>
    </Modal>
  );
};

export default AppSetupModal;
